var React = require('react');

function TransactionHistory (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Icon/history"},React.createElement("path",{"id":"Icon Stroke","d":"M13 7V12H17M6.85868 13.2278L5.4906 16.9866L1.73183 15.6185M5.51075 16.9928C4.55641 15.5642 4 13.8471 4 12C4 7.02944 8.02944 3 13 3C17.9706 3 22 7.02944 22 12C22 16.9706 17.9706 21 13 21C11.1529 21 9.43584 20.4436 8.00717 19.4892","stroke":"#00121A","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"})));
}

TransactionHistory.defaultProps = {"width":"25","height":"24","viewBox":"0 0 25 24","fill":"none"};

module.exports = TransactionHistory;

TransactionHistory.default = TransactionHistory;
